import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import MenuIcon from "@material-ui/icons/Menu";
import { Link } from "react-router-dom";
import "./Navbar.css";

const useStyles = makeStyles({
  list: {
    width: 200
  },
  fullList: {
    width: "auto"
  }
});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  });

  const toggleDrawer = (side, open) => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <Link id="lnk" to="/" style={{ color: "black", marginTop: "15px" }}>
          {/* <ListItemText id='linksTxt' primary="Home" /> */}
          <Button id="linksTxt">Home</Button>
        </Link>{" "}
        <br />
        <Link
          id="lnk"
          to="/Notes"
          style={{ color: "black", marginTop: "15px" }}
        >
          <Button id="linksTxt">Notes</Button>
        </Link>
        <br />
        <Link id="lnk" to="/QuestionBank" style={{ color: "black", marginTop: "15px" }}>
          <Button id="linksTxt">Question Bank</Button>
        </Link>
        <br />
        <Link
          id="lnk"
          to="/projects"
          style={{ color: "black", marginTop: "15px" }}
        >
          <Button id="linksTxt">Projects</Button>
        </Link>
        <br />
        <Link
          id="lnk"
          to="/VideoClass"
          style={{ color: "black", marginTop: "15px" }}
        >
          <Button id="linksTxt">Video class</Button>
        </Link>
        <br />
        <Link
          id="lnk"
          to="/community"
          style={{ color: "black", marginTop: "15px" }}
        >
          <Button id="linksTxt">Community</Button>
        </Link>
        <br />
        <Link
          id="lnk"
          to="/about"
          style={{ color: "black", marginTop: "15px" }}
        >
          <Button id="linksTxt">About us</Button>
        </Link>
        <br />
      </List>
      <Divider />
      <br />
      <Link
        id="lnk"
        to="/Calculator"
        style={{ color: "black", marginTop: "205px" }}
      >
        <Button id="linksTxt">SGPA/CGPA Calculator</Button>
      </Link>
      <br />
      <Link
        id="lnk"
        to="/download"
        style={{ color: "black", marginTop: "15px" }}
      >
        <Button id="linksTxt">Download APP</Button>
      </Link>
    </div>
  );

 
  return (
    <div>
      <Button
        style={{ color: "white", marginLeft: "-20px" }}
        onClick={toggleDrawer("left", true)}
      >
        <MenuIcon />
      </Button>
      <Drawer
        open={state.left}
        onClose={toggleDrawer("left", false)}
        style={{ textAlign: "center", textDecoration: "none", color: "black" }}
      >
        <div
          style={{
            backgroundColor: "#10ac84",
            height: "60px",
            fontSize: "35px",
            color: "white"
          }}
        >
          <p style={{ marginTop: "5px" }}>V.N</p>
        </div>
        {sideList("left")}
      </Drawer>
      {/* <Drawer anchor="right" open={state.right} onClose={toggleDrawer('right', false)}>
                {sideList('right')}
            </Drawer> */}
    </div>
  );
}
